import iconright from 'assets/images/iconright.svg'
import { Link, useLocation, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentEvent, setCurrentEvent, setStatus } from 'features/slices/eventSlice'
import Audience from 'components/Audience/Audience'
import Customize from 'components/Customize/Customize'
import Templates from 'components/Templates/Templates'
import Activity from 'components/Activity/Activity'
import pauseicon from 'assets/images/pauseicon.svg'
import launcherror from 'assets/images/launcherror.svg'
import axios from 'axios'
import resumebtn from 'assets/images/resumebtn.svg'
import { auth } from '../../firebase'
import { useAuthState } from 'react-firebase-hooks/auth'
import Footer from 'components/Footer/Footer'
import './EventInfo.scss'
import { ClipLoader } from 'react-spinners'
import { Tooltip } from '@mui/material'

const BACKEND_API = process.env.REACT_APP_BACKEND_API

const EventInfo = () => {
  const [activeCustom, setActiveCustom] = useState('/audience')
  const dispatch = useDispatch()

  const [user, loading] = useAuthState(auth)
  const [expiredBool, setExpiredBool] = useState<null | boolean | string>(false)
  const location = useLocation()
  const { id } = useParams()

  useEffect(() => {
    const fetchSingleEvent = async () => {
      const { data } = await axios.get(`${BACKEND_API}/events/event/${id}`, {
        headers: {
          Authorization: `Bearer ${await user?.getIdToken(true)}`,
        },
      })
      dispatch(setCurrentEvent(data))
    }
    fetchSingleEvent()
    const option = localStorage.getItem('option') || ''
    setActiveCustom(option)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const currentEvent = useSelector(getCurrentEvent)

  const handleLaunch = async () => {
    dispatch(setStatus('Launched'))
    axios.patch(
      `${BACKEND_API}/events/event/${id}`,
      { status: 'Launched' },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await user?.getIdToken(true)}`,
        },
      },
    )
  }

  const handlePause = async () => {
    await axios.patch(
      `${BACKEND_API}/events/event/${id}`,
      { status: 'Paused' },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await user?.getIdToken(true)}`,
        },
      },
    )
    dispatch(setStatus('Paused'))
  }

  useEffect(() => {
    const isExpired = JSON.parse(localStorage.getItem('unsubscribed') || '')
    setExpiredBool(isExpired)
  }, [])

  return (
    <section className='eventinfo_wrapper'>
      {currentEvent.name ? (
        <>
          <div className='container' style={{ marginTop: '36px' }}>
            <div className='eventinfo_top'>
              <div className='eventinfo_top_left'>
                <Link className='p' to='/events'>
                  All Events
                </Link>
                <img src={iconright} alt='iconright' />
                <p
                  title={currentEvent.name}
                  style={{
                    fontSize: '14px',
                    wordBreak: 'break-all',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    inlineSize: '400px',
                  }}
                  id={location.state.page === '/audience' ? 'orange' : ''}
                >
                  {currentEvent.name}
                </p>
              </div>
              {currentEvent.archived === false && !expiredBool ? (
                <div className='eventinfo_top_right'>
                  <Link to={`/share/${id}`} target={'_blank'} className='preview'>
                    Preview
                  </Link>
                  {currentEvent.status === 'Launched' ? (
                    <button
                      className='launch'
                      type='button'
                      onClick={handlePause}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <img style={{ marginRight: '5px' }} src={pauseicon} alt='pauseicon' />
                      Pause
                    </button>
                  ) : currentEvent.status === 'Paused' ? (
                    <button
                      className='launch'
                      type='button'
                      onClick={handleLaunch}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <img style={{ marginRight: '5px' }} src={resumebtn} alt='pauseicon' />
                      Resume
                    </button>
                  ) : (
                    <button className='launch' type='button' onClick={handleLaunch}>
                      Launch
                    </button>
                  )}
                </div>
              ) : (
                <div className='eventinfo_top_right'>
                  <Link to={`/share/${id}`} target={'_blank'} className='preview'>
                    Preview
                  </Link>
                  {expiredBool ? (
                    <Tooltip
                      title='You are unsubscribed'
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: '#1B1B1E',
                            '& .MuiTooltip-arrow': {
                              color: '#1B1B1E',
                            },
                          },
                        },
                      }}
                    >
                      <button className='disabledlaunch' type='button'>
                        Launch
                      </button>
                    </Tooltip>
                  ) : (
                    <>
                      <button className='disabledlaunch' type='button'>
                        Launch
                      </button>
                      <img src={launcherror} alt='launch error' className='launcherror' />
                    </>
                  )}
                </div>
              )}
            </div>
            <div className='container'>
              <div className='flex_start' style={{ marginTop: '8px' }}>
                <p title={currentEvent.name} className='eventName'>
                  {currentEvent.name}{' '}
                </p>
                <div
                  style={{ marginLeft: '10px' }}
                  className={
                    currentEvent.status === 'Not Started'
                      ? 'grey'
                      : currentEvent.status === 'Launched'
                      ? 'green'
                      : 'yellow'
                  }
                ></div>
                <p style={{ marginLeft: '5px', fontSize: '15px' }}>
                  {currentEvent.status === 'Not Started'
                    ? ' Not Launched'
                    : currentEvent.status === 'Launched'
                    ? 'Launched'
                    : 'Paused'}
                </p>
              </div>
            </div>
            <div className='container'>
              <div className='eventinfo_middle'>
                <ul>
                  <li
                    onClick={() => {
                      setActiveCustom('/audience')
                      localStorage.setItem('option', '/audience')
                    }}
                    data-intercom-target='audience'
                    className={
                      activeCustom === '/audience'
                        ? ' campaignLink campaignLink_active'
                        : 'campaignLink'
                    }
                  >
                    {activeCustom === '/audience' ? (
                      <svg
                        className='svg'
                        width='32'
                        height='32'
                        viewBox='0 0 32 32'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M9.60024 15.9998C12.6952 15.9998 15.2002 13.4948 15.2002 10.3998C15.2002 7.3048 12.6952 4.7998 9.60024 4.7998C6.50524 4.7998 4.00024 7.3048 4.00024 10.3998C4.00024 13.4948 6.50524 15.9998 9.60024 15.9998ZM13.4402 17.5998H13.0252C11.9852 18.0998 10.8302 18.3998 9.60024 18.3998C8.37024 18.3998 7.22024 18.0998 6.17524 17.5998H5.76024C2.58024 17.5998 0.000244141 20.1798 0.000244141 23.3598V24.7998C0.000244141 26.1248 1.07524 27.1998 2.40024 27.1998H16.8002C18.1252 27.1998 19.2002 26.1248 19.2002 24.7998V23.3598C19.2002 20.1798 16.6202 17.5998 13.4402 17.5998ZM24.0002 15.9998C26.6502 15.9998 28.8002 13.8498 28.8002 11.1998C28.8002 8.5498 26.6502 6.3998 24.0002 6.3998C21.3502 6.3998 19.2002 8.5498 19.2002 11.1998C19.2002 13.8498 21.3502 15.9998 24.0002 15.9998ZM26.4002 17.5998H26.2102C25.5152 17.8398 24.7802 17.9998 24.0002 17.9998C23.2202 17.9998 22.4852 17.8398 21.7902 17.5998H21.6002C20.5802 17.5998 19.6402 17.8948 18.8152 18.3698C20.0352 19.6848 20.8002 21.4298 20.8002 23.3598V25.2798C20.8002 25.3898 20.7752 25.4948 20.7702 25.5998H29.6002C30.9252 25.5998 32.0002 24.5248 32.0002 23.1998C32.0002 20.1048 29.4952 17.5998 26.4002 17.5998Z'
                          fill='#1D4842'
                        />
                      </svg>
                    ) : (
                      <svg
                        className='svg'
                        width='32'
                        height='32'
                        viewBox='0 0 32 32'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path d='M9.6 15.9998C12.695 15.9998 15.2 13.4948 15.2 10.3998C15.2 7.3048 12.695 4.7998 9.6 4.7998C6.505 4.7998 4 7.3048 4 10.3998C4 13.4948 6.505 15.9998 9.6 15.9998ZM13.44 17.5998H13.025C11.985 18.0998 10.83 18.3998 9.6 18.3998C8.37 18.3998 7.22 18.0998 6.175 17.5998H5.76C2.58 17.5998 0 20.1798 0 23.3598V24.7998C0 26.1248 1.075 27.1998 2.4 27.1998H16.8C18.125 27.1998 19.2 26.1248 19.2 24.7998V23.3598C19.2 20.1798 16.62 17.5998 13.44 17.5998ZM24 15.9998C26.65 15.9998 28.8 13.8498 28.8 11.1998C28.8 8.5498 26.65 6.3998 24 6.3998C21.35 6.3998 19.2 8.5498 19.2 11.1998C19.2 13.8498 21.35 15.9998 24 15.9998ZM26.4 17.5998H26.21C25.515 17.8398 24.78 17.9998 24 17.9998C23.22 17.9998 22.485 17.8398 21.79 17.5998H21.6C20.58 17.5998 19.64 17.8948 18.815 18.3698C20.035 19.6848 20.8 21.4298 20.8 23.3598V25.2798C20.8 25.3898 20.775 25.4948 20.77 25.5998H29.6C30.925 25.5998 32 24.5248 32 23.1998C32 20.1048 29.495 17.5998 26.4 17.5998Z' />
                      </svg>
                    )}

                    <p className={activeCustom === '/audience' ? 'filter_green' : ''}>Audience</p>
                  </li>
                  <li
                    onClick={() => {
                      setActiveCustom('/customize')
                      localStorage.setItem('option', '/customize')
                    }}
                    data-intercom-target='customize'
                    className={
                      activeCustom === '/customize'
                        ? 'campaignLink campaignLink_active'
                        : 'campaignLink'
                    }
                  >
                    {activeCustom === '/customize' ? (
                      <svg
                        className='svg'
                        width='33'
                        height='32'
                        viewBox='0 0 33 32'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M31.6352 6.80046C31.6352 5.86712 31.2407 5.06712 30.7148 4.40046L27.6907 1.33379C26.6389 0.267122 24.6667 0.133789 23.4833 1.33379L4.81296 20.4005C4.68148 20.5338 4.68148 20.6671 4.68148 20.8005C4.28704 21.4671 3.49815 23.4671 1.26296 29.3338C1 29.8671 1.13148 30.5338 1.65741 31.0671C1.92037 31.3338 2.4463 31.6005 2.84074 31.6005C2.97222 31.6005 3.23519 31.6005 3.36667 31.4671C9.28333 29.2005 11.1241 28.4005 11.7815 28.1338C11.913 28.1338 12.0444 28.0005 12.1759 28.0005L30.7148 9.20046C31.2407 8.53379 31.6352 7.73379 31.6352 6.80046ZM2.84074 30.2671C2.70926 30.2671 2.57778 30.2671 2.57778 30.1338C2.4463 30.0005 2.4463 29.8671 2.4463 29.8671C2.70926 29.2005 3.1037 28.2671 3.36667 27.4671L5.20741 29.3338C4.41852 29.6005 3.62963 30.0005 2.84074 30.2671ZM6.52222 28.8005L3.89259 26.1338C4.55 24.5338 5.07593 23.0671 5.47037 22.1338L8.49445 25.2005L10.5981 27.3338C9.67778 27.6005 8.1 28.1338 6.52222 28.8005ZM29.7944 8.26712L11.7815 26.5338L9.94074 24.6671L24.6667 9.73379C24.9296 9.46712 24.9296 9.06712 24.6667 8.80046C24.4037 8.53379 24.0093 8.53379 23.7463 8.80046L8.88889 23.7338L6.12778 20.9338L24.4037 2.40046C25.0611 1.73379 26.113 1.73379 26.7704 2.40046L29.7944 5.46712C30.1889 5.86712 30.3204 6.40046 30.3204 6.93379C30.3204 7.46712 30.0574 7.86712 29.7944 8.26712ZM1.26296 9.20046C1.13148 9.06712 1 8.80046 1 8.66712C1 8.53379 1.13148 8.26712 1.13148 8.13379L8.88889 0.267122C9.02037 0.133789 9.15185 0.133789 9.41482 0.133789C9.67778 0.133789 9.80926 0.267122 9.94074 0.267122L15.9889 6.66712C16.2519 6.93379 16.2519 7.33379 15.9889 7.60046C15.7259 7.86712 15.3315 7.86712 15.0685 7.60046L9.41482 1.86712L2.57778 8.66712L4.15556 10.2671L7.96852 6.40046C8.23148 6.13379 8.62593 6.13379 8.88889 6.40046C9.15185 6.66712 9.15185 7.06712 8.88889 7.33379L5.07593 11.2005L6.39074 12.5338L7.70556 11.2005C7.96852 10.9338 8.36296 10.9338 8.62593 11.2005C8.88889 11.4671 8.88889 11.8671 8.62593 12.1338L7.31111 13.4671L8.23148 14.4005C8.49444 14.6671 8.49444 15.0671 8.23148 15.3338C8.1 15.4671 7.96852 15.4671 7.70556 15.4671C7.57407 15.4671 7.31111 15.4671 7.17963 15.3338L1.26296 9.20046ZM32.1611 24.0005L24.5352 31.7338C24.4037 31.8671 24.2722 31.8671 24.0093 31.8671C23.8778 31.8671 23.6148 31.8671 23.4833 31.7338L17.1722 25.3338C16.9093 25.0671 16.9093 24.6671 17.1722 24.4005C17.4352 24.1338 17.8296 24.1338 18.0926 24.4005L19.1444 25.4671L20.4593 24.1338C20.7222 23.8671 21.1167 23.8671 21.3796 24.1338C21.6426 24.4005 21.6426 24.8005 21.3796 25.0671L20.0648 26.4005L21.5111 27.8671L25.3241 24.0005C25.587 23.7338 25.9815 23.7338 26.2444 24.0005C26.5074 24.2671 26.5074 24.6671 26.2444 24.9338L22.4315 28.8005L23.8778 30.2671L30.5833 23.4671L24.6667 17.4671C24.4037 17.2005 24.4037 16.8005 24.6667 16.5338C24.9296 16.2671 25.3241 16.2671 25.587 16.5338L31.8982 22.9338C32.4241 23.3338 32.4241 23.7338 32.1611 24.0005Z'
                          fill='#1D4842'
                        />
                      </svg>
                    ) : (
                      <svg
                        className='svg'
                        width='32'
                        height='32'
                        viewBox='0 0 32 32'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path d='M31.179 6.80046C31.179 5.86712 30.779 5.06712 30.2456 4.40046L27.179 1.33379C26.1123 0.267122 24.1123 0.133789 22.9123 1.33379L3.97897 20.4005C3.84564 20.5338 3.84564 20.6671 3.84564 20.8005C3.44564 21.4671 2.64564 23.4671 0.378971 29.3338C0.112305 29.8671 0.245638 30.5338 0.778971 31.0671C1.04564 31.3338 1.57897 31.6005 1.97897 31.6005C2.1123 31.6005 2.37897 31.6005 2.5123 31.4671C8.51231 29.2005 10.379 28.4005 11.0456 28.1338C11.179 28.1338 11.3123 28.0005 11.4456 28.0005L30.2456 9.20046C30.779 8.53379 31.179 7.73379 31.179 6.80046ZM1.97897 30.2671C1.84564 30.2671 1.7123 30.2671 1.7123 30.1338C1.57897 30.0005 1.57897 29.8671 1.57897 29.8671C1.84564 29.2005 2.24564 28.2671 2.5123 27.4671L4.37897 29.3338C3.57897 29.6005 2.77897 30.0005 1.97897 30.2671ZM5.71231 28.8005L3.04564 26.1338C3.7123 24.5338 4.24564 23.0671 4.64564 22.1338L7.71231 25.2005L9.84564 27.3338C8.9123 27.6005 7.31231 28.1338 5.71231 28.8005ZM29.3123 8.26712L11.0456 26.5338L9.17897 24.6671L24.1123 9.73379C24.379 9.46712 24.379 9.06712 24.1123 8.80046C23.8456 8.53379 23.4456 8.53379 23.179 8.80046L8.1123 23.7338L5.3123 20.9338L23.8456 2.40046C24.5123 1.73379 25.579 1.73379 26.2456 2.40046L29.3123 5.46712C29.7123 5.86712 29.8456 6.40046 29.8456 6.93379C29.8456 7.46712 29.579 7.86712 29.3123 8.26712ZM0.378971 9.20046C0.245638 9.06712 0.112305 8.80046 0.112305 8.66712C0.112305 8.53379 0.245638 8.26712 0.245638 8.13379L8.1123 0.267122C8.24564 0.133789 8.37897 0.133789 8.64564 0.133789C8.9123 0.133789 9.04564 0.267122 9.17897 0.267122L15.3123 6.66712C15.579 6.93379 15.579 7.33379 15.3123 7.60046C15.0456 7.86712 14.6456 7.86712 14.379 7.60046L8.64564 1.86712L1.7123 8.66712L3.3123 10.2671L7.17897 6.40046C7.44564 6.13379 7.84564 6.13379 8.1123 6.40046C8.37897 6.66712 8.37897 7.06712 8.1123 7.33379L4.24564 11.2005L5.57897 12.5338L6.9123 11.2005C7.17897 10.9338 7.57897 10.9338 7.84564 11.2005C8.11231 11.4671 8.11231 11.8671 7.84564 12.1338L6.51231 13.4671L7.44564 14.4005C7.71231 14.6671 7.71231 15.0671 7.44564 15.3338C7.3123 15.4671 7.17897 15.4671 6.9123 15.4671C6.77897 15.4671 6.51231 15.4671 6.37897 15.3338L0.378971 9.20046ZM31.7123 24.0005L23.979 31.7338C23.8456 31.8671 23.7123 31.8671 23.4456 31.8671C23.3123 31.8671 23.0456 31.8671 22.9123 31.7338L16.5123 25.3338C16.2456 25.0671 16.2456 24.6671 16.5123 24.4005C16.779 24.1338 17.179 24.1338 17.4456 24.4005L18.5123 25.4671L19.8456 24.1338C20.1123 23.8671 20.5123 23.8671 20.779 24.1338C21.0456 24.4005 21.0456 24.8005 20.779 25.0671L19.4456 26.4005L20.9123 27.8671L24.779 24.0005C25.0456 23.7338 25.4456 23.7338 25.7123 24.0005C25.979 24.2671 25.979 24.6671 25.7123 24.9338L21.8456 28.8005L23.3123 30.2671L30.1123 23.4671L24.1123 17.4671C23.8456 17.2005 23.8456 16.8005 24.1123 16.5338C24.379 16.2671 24.779 16.2671 25.0456 16.5338L31.4456 22.9338C31.979 23.3338 31.979 23.7338 31.7123 24.0005Z' />
                      </svg>
                    )}

                    <p className={activeCustom === '/customize' ? 'filter_green' : ''}>Customize</p>
                  </li>

                  <li
                    onClick={() => {
                      setActiveCustom('/activity')
                      localStorage.setItem('option', '/activity')
                    }}
                    className={
                      activeCustom === '/activity'
                        ? 'campaignLink campaignLink_active'
                        : 'campaignLink'
                    }
                  >
                    {activeCustom === '/activity' ? (
                      <svg
                        className='svg'
                        width='33'
                        height='32'
                        viewBox='0 0 33 32'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M31.7749 17.5999H24.89L22.0213 11.1999C21.9257 10.909 21.6388 10.812 21.352 10.812C21.0651 10.812 20.8738 11.1029 20.7782 11.2969L18.1008 26.4241L13.1284 1.98778C13.1284 1.69687 12.8415 1.50293 12.5547 1.50293C12.2678 1.50293 11.9809 1.69687 11.8853 1.98778L8.06039 18.8605H1.55803C1.17554 18.8605 0.888672 19.1514 0.888672 19.4423C0.888672 19.8302 1.17554 20.1211 1.46241 20.1211C1.46241 20.1211 1.46241 20.1211 1.55803 20.1211H8.5385C8.82537 20.1211 9.11224 19.9272 9.20786 19.6363L12.459 5.28475L17.4314 30.012C17.527 30.3029 17.8139 30.4969 18.1008 30.4969C18.3877 30.4969 18.6745 30.3029 18.7701 29.915L21.7345 13.5272L23.8382 18.2787C23.9338 18.4726 24.2206 18.6666 24.4119 18.6666H31.7749C32.1573 18.6666 32.4442 18.4726 32.4442 18.0847C32.4442 17.6969 32.253 17.406 31.8705 17.406C31.8705 17.5999 31.8705 17.5999 31.7749 17.5999Z'
                          fill='#1D4842'
                        />
                      </svg>
                    ) : (
                      <svg
                        width='33'
                        height='32'
                        viewBox='0 0 33 32'
                        xmlns='http://www.w3.org/2000/svg'
                        className='svg'
                      >
                        <path d='M31.7749 17.5999H24.89L22.0213 11.1999C21.9257 10.909 21.6388 10.812 21.352 10.812C21.0651 10.812 20.8738 11.1029 20.7782 11.2969L18.1008 26.4241L13.1284 1.98778C13.1284 1.69687 12.8415 1.50293 12.5547 1.50293C12.2678 1.50293 11.9809 1.69687 11.8853 1.98778L8.06039 18.8605H1.55803C1.17554 18.8605 0.888672 19.1514 0.888672 19.4423C0.888672 19.8302 1.17554 20.1211 1.46241 20.1211C1.46241 20.1211 1.46241 20.1211 1.55803 20.1211H8.5385C8.82537 20.1211 9.11224 19.9272 9.20786 19.6363L12.459 5.28475L17.4314 30.012C17.527 30.3029 17.8139 30.4969 18.1008 30.4969C18.3877 30.4969 18.6745 30.3029 18.7701 29.915L21.7345 13.5272L23.8382 18.2787C23.9338 18.4726 24.2206 18.6666 24.4119 18.6666H31.7749C32.1573 18.6666 32.4442 18.4726 32.4442 18.0847C32.4442 17.6969 32.253 17.406 31.8705 17.406C31.8705 17.5999 31.8705 17.5999 31.7749 17.5999Z' />
                      </svg>
                    )}

                    <p className={activeCustom === '/activity' ? 'filter_green' : ''}>Activity</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className='line' style={{ marginTop: '20px' }}></div>
            <div className='campaigninfo_bottom'>
              {(() => {
                switch (activeCustom) {
                  case '/audience':
                    return <Audience />
                  case '/customize':
                    return <Customize />
                  case '/templates':
                    return <Templates />
                  case '/activity':
                    return <Activity />
                  default:
                    return <Audience />
                }
              })()}
            </div>
          </div>
          <Footer />
        </>
      ) : (
        <div className='flex_center' style={{ marginTop: '100px' }}>
          <ClipLoader color='#1D4842' size={20} speedMultiplier={1.2} />
        </div>
      )}
    </section>
  )
}

export default EventInfo
